// extracted by mini-css-extract-plugin
export default {"more":"LoadMore_more__2uaTX","btn":"LoadMore_btn__1W-jC","ant-btn":"LoadMore_ant-btn__2RDUn","info":"LoadMore_info__lSPsT"};